$(document).on('blur', '.form-control', function() {
    if ($(this).val())
        $(this).addClass('used');
    else
        $(this).removeClass('used');
});


// WEBPACK FOOTER //
// ./themes/wild/assets/js/forms.js